import { useContext } from 'react';

import { ServiceContext } from './ServiceContext';
import { Services } from './serviceTypes';

export const useServices = (): Services => {
  const context = useContext(ServiceContext);
  if (!context) {
    throw new Error('useServices must be used within a ServiceProvider');
  }
  return context;
};
